<script>
import CheckboxField from '@phoenix/mixins/components/form/fields/CheckboxField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxField],

  props: {
    modelValue: {
      type: [Boolean, Array],
      default: false,
    },
    extraClasses: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    inputAttrs: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxClasses() {
      return ['switch', this.extraClasses, { 'switch--error': this.isInvalid }];
    },

    inputClasses() {
      return ['switch__input', this.inputClass];
    },

    labelClasses() {
      return ['input-label switch__label checkbox-label', { 'input-label--error': this.isInvalid }];
    },

    inputValue() {
      return Array.isArray(this.value) ? this.field.value : null;
    },
  },
};
</script>

<template>
  <div :class="checkboxClasses">
    <input
      :id="fieldUniqueId"
      v-model="value"
      :value="inputValue"
      :name="field.name"
      :data-cy="field.dataCy"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      :class="inputClasses"
      v-bind="inputAttrs"
      @focus="pushFieldDataTracking"
    />
    <label v-if="hasLabelSlot" :for="fieldUniqueId" :class="labelClasses">
      <slot name="label" />
    </label>
    <label v-else :for="fieldUniqueId" :class="labelClasses">
      <span class="input-label__text" v-html="field.label" />
    </label>
  </div>
</template>
